import React from 'react';

import Types from '../../modules/types';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import { StoreLink } from '../../components/Links';
 // eslint-disable-next-line max-len
import { columnCreatedAt, columnUpdatedAt } from '../../components/common';
 // eslint-disable-next-line max-len
export const columnAdjustmentName = { path: 'name', sort: 'name' };
 // eslint-disable-next-line max-len
export const columnAdjustmentType = { path: 'Type', sort: 'Type' };

export const ADMIN = [
  columnAdjustmentName,
  columnAdjustmentType,
  columnCreatedAt,
  columnUpdatedAt,
];
